import { render, staticRenderFns } from "./TempLayout.vue?vue&type=template&id=2437fcea&"
import script from "./TempLayout.vue?vue&type=script&lang=js&"
export * from "./TempLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports